export function fmtCurrency(value, currency = "EUR") {
  if (value == null || Number.isNaN(value)) return "unavailable";
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${value.toFixed(2)} ${currency}`;
  }
}

// Display helpers — presentation only. Storage/API always stay ISO (YYYY-MM-DD).
// Renders day/month/year (dd/mm/yyyy) deterministically, independent of browser locale.
export function fmtDate(value) {
  if (!value) return "";
  const s = String(value);
  // Pure date-only string: format directly to avoid timezone off-by-one shifts.
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s.slice(0, 10));
  if (m && s.length <= 10) return `${m[3]}/${m[2]}/${m[1]}`;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return s;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export function fmtDateTime(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()} ${hh}:${min}`;
}

export const ASSET_META = {
  crypto: { label: "Crypto", color: "#B7A9C8" },
  stocks: { label: "Stocks", color: "#9DB7C5" },
  commodities: { label: "Commodities", color: "#D6C3A5" },
  housing: { label: "Housing", color: "#A8C3A0" },
  cash: { label: "Cash", color: "#8FB9B2" },
  other: { label: "Other", color: "#CFA6AA" },
};
